import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unassigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	genericErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	genericErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unassigned: {
		id: 'software-releases-version-driver-field.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Placeholder text when no driver is assigned to the version',
	},
	fieldLabel: {
		id: 'software-releases-version-driver-field.field-label',
		defaultMessage: 'Driver',
		description: "Version driver picker's label",
	},
	genericErrorFlagTitle: {
		id: 'software-releases-version-driver-field.generic-error-flag-title',
		defaultMessage: "We couldn't update the version driver.",
		description: 'The title of the flag that is displayed when updating version driver fails.',
	},
	genericErrorFlagDescription: {
		id: 'software-releases-version-driver-field.generic-error-flag-description',
		defaultMessage:
			'Something went wrong. Please try again or contact your administrator if the problem persists.',
		description:
			'The description of the flag that is displayed when updating version driver fails.',
	},
});
export default messages;
